import { Component, Input } from '@angular/core';
import { BxUnverifiedAlertService } from '../../../../core/services/bx-unverified-alert.service';
import { SharedDataService } from '../../../../data/services/shared-data.service';
import { ClientsService } from '../../clients.service';

@Component({
    selector: 'app-clients-email-list',
    templateUrl: './clients-email-list.component.html',
    standalone: false,
})
export class ClientsEmailListComponent {
    // @ts-ignore TS7008
    @Input() customer;

    constructor(
        private clientsService: ClientsService,
        private readonly bxUnverifiedAlertService: BxUnverifiedAlertService,
        private sharedData: SharedDataService
    ) {}

    newEmail() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }
        this.clientsService.emailCustomer(this.customer.ID_Customer);
    }
}
